import { IconCheck, IconSparkles } from "@tabler/icons-react";

/** A compact ledger motif: AI proposals enter, reviewed rows leave reconciled. */
export function ApprovalEmptyIllustration() {
  return (
    <div aria-hidden="true" className="relative h-20 w-32">
      <div className="absolute inset-x-5 top-1 h-14 -rotate-3 rounded-lg border bg-muted shadow-sm" />
      <div className="absolute inset-x-3 top-3 h-14 rotate-2 rounded-lg border bg-card shadow-sm" />
      <div className="absolute inset-x-0 top-5 flex h-14 items-center gap-3 rounded-lg border bg-background px-4 shadow-sm">
        <span className="flex size-7 items-center justify-center rounded-full bg-success/10 text-success-foreground">
          <IconCheck />
        </span>
        <span className="flex flex-1 flex-col gap-1.5">
          <span className="h-1.5 w-full rounded-full bg-muted-foreground/20" />
          <span className="h-1.5 w-2/3 rounded-full bg-muted-foreground/10" />
        </span>
        <IconSparkles className="text-muted-foreground" />
      </div>
    </div>
  );
}
